import Plugin from '../Plugin'


export default class Igloo extends Plugin {

    constructor(network) {
        super(network)
        this.events = {
            'add_igloo': this.addIgloo,
            'add_furniture': this.addFurniture,
            'update_flooring': this.updateFlooring,
            'update_music': this.updateMusic,
            'get_igloos': this.getIgloos,
            'get_igloo_open': this.getIglooOpen
        }
    }

    get client() {
        return this.world.client
    }

    get gridView() {
        return this.interface.iglooEdit.gridView
    }

    addIgloo(args) {
        let inventory = this.client.igloos

        this.client.coins = args.coins
        inventory.push(args.igloo)
        inventory.sort((a, b) => a - b)

        this.interface.refreshPlayerCard()

        if (this.gridView && this.gridView.visible) {
            this.interface.iglooEdit.showGridView()
        }

        this.interface.updateCatalogCoins(args.coins)

        // Show prompt (z-index management in PromptController handles overlay visibility)
        let text = `${this.crumbs.igloos[args.igloo].name}\nhas been added to your inventory.`
        this.interface.prompt.showWindow(text, 'single')
    }

    addFurniture(args) {
        let inventory = this.client.furniture

        const amount = Math.max(1, parseInt(args.amount, 10) || 1)
        const currentQuantity = parseInt(inventory[args.furniture], 10) || 0

        this.client.coins = args.coins
        inventory[args.furniture] = currentQuantity + amount

        this.interface.refreshPlayerCard()

        if (this.gridView && this.gridView.visible) {
            this.interface.iglooEdit.showGridView()
        }

        this.interface.updateCatalogCoins(args.coins)

        const furnitureName = this.crumbs.furniture[args.furniture]?.name || 'Furniture'
        const text = (amount > 1)
            ? `${furnitureName} x${amount}\nhave been added to your inventory.`
            : `${furnitureName}\nhas been added to your inventory.`

        // Show prompt (z-index management in PromptController handles overlay visibility)
        this.interface.prompt.showWindow(text, 'single')
    }

    updateFlooring(args) {
        if (!this.world.room.isIgloo) return

        this.world.room.updateFlooring(args.flooring)
        this.client.coins = args.coins

        this.interface.refreshPlayerCard()
    }

    updateMusic(args) {
        if (!this.world.room.isIgloo) return

        this.world.room.updateMusic(args.music)
    }

    getIgloos(args) {
        const map = this.interface.widgets.getWidget('Map')

        if (map) {
            map.iglooMap.setIgloos(args.igloos)
        }
    }

    getIglooOpen(args) {
        if (args.open) {
            this.interface.main.playerCard.buttons.enableButton('igloo')
        }
    }

}
